var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3576 12.6563H28.3593H17.3437V1.66146C17.3437 0.756585 16.611 0 15.7061 0H14.2966C13.392 0 12.6561 0.756585 12.6561 1.66146V12.6563H1.64073C0.736342 12.6563 0 13.388 0 14.2932V15.7107C0 16.6151 0.736098 17.3437 1.64073 17.3437H12.6563V28.3783C12.6563 29.2827 13.392 29.9998 14.2968 29.9998H15.7063C16.6112 29.9998 17.3439 29.2824 17.3439 28.3783V17.3437H28.3576C29.2624 17.3437 30 16.6149 30 15.7107V14.2932C30 13.388 29.2624 12.6563 28.3576 12.6563Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/IconPlus.ff393df2da392df7cf31fafe10251943.svg";
export { ForwardRef as ReactComponent };